import React from 'react'
export default function Header({ lang, setLang, t, go }) {
  const [open, setOpen] = React.useState(false)
  return (
    <header className="header">
      <div className="container nav">
        <button className="brand" onClick={() => go('top')}>
          <span className="brand-mark">GH</span>
          <span>
            <b>Gabriel Huayamabe</b>
            <small>SOFTWARE ENGINEER</small>
          </span>
        </button>
        <button
          className="menu"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          <i />
          <i />
          <i />
        </button>
        <nav className={open ? 'open' : ''}>
          {Object.entries(t).map(([id, label]) => (
            <button
              key={id}
              onClick={() => {
                go(id)
                setOpen(false)
              }}
            >
              {label}
            </button>
          ))}
        </nav>
        <div className="actions">
          <div className="lang">
            <span className="lang-label">🌐 Language</span>

            <button
              className={lang === 'en' ? 'active' : ''}
              onClick={() => setLang('en')}
            >
              EN
            </button>

            <button
              className={lang === 'es' ? 'active' : ''}
              onClick={() => setLang('es')}
            >
              ES
            </button>
          </div>
          <button className="talk" onClick={() => go('contact')}>
            {lang === 'en' ? "Let's talk" : 'Hablemos'} <span>→</span>
          </button>
        </div>
      </div>
    </header>
  )
}
